import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import routes from './routes'
import store from './store'
import vuetify from './plugins/vuetify';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '@fortawesome/fontawesome-free/css/all.css'
import VueMeta from 'vue-meta'

import Vuelidate from 'vuelidate'
import i18n from './i18n'
Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueMeta)


Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


Vue.config.productionTip = false


router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth == true)) {
        if (localStorage.getItem('token') == null) {
            next({
                name: 'Login',
            })
        }
        if (!store.getters.loggedIn) {
            next({
                name: 'Login',
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresAuth == false)) {
        if (store.getters.loggedIn) {
            next({
                name: 'Home',
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresAuth == 'GUEST')){
        next()
    }
})


new Vue({
    iconfont: 'fa',
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')

export {router}